import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LandingComponent } from '@approot/app-landing';
import { AuthenticationGuard, ForceHTTPSGuard, CheckLocationGuard, StartOrderGuard, SubNavGuard, VisitsGuard, CiamV6Guard, Auth0MagicLinkRedirectGuard } from '@core/guards';
import { HomeComponent } from '@features/home';
import { OrderDetailComponent } from '@features/ordering/modals/modals.index';


// TODO this is test code to work on my order cart summary modal screen and needs to be removed later once
// the flyout for it is set properly along with the route made below
import * as OrderModals from '@features/ordering/modals/modals.index';
import { LoginWithPaypalComponent } from '@shared/components/login-with-paypal';
import { Auth0CallbackComponent } from '@features/authenticate/auth0-callback';
export class AppModule {}
export const appRoutes: Routes = [
  // redirect to home by default - but dont strip the query params
  { path: '', redirectTo: 'home', pathMatch: 'full' },

  // Lazy load the modules on the main App Component landing page
  {
    path: 'home',
    component: LandingComponent,
    children: [
      { path: '', component: HomeComponent },
    ],
    canActivate: [ForceHTTPSGuard, SubNavGuard, Auth0MagicLinkRedirectGuard]
  },
  {
    path: 'home',
    component: LandingComponent,
    loadChildren: () => import('@footer-links/footer-links.module').then(m => m.FooterLinksModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard, Auth0MagicLinkRedirectGuard]
  },
  {
    path: 'order-details',
    component: LandingComponent,
    children: [
      { path: '', component: OrderDetailComponent },
    ],
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'account',
    component: LandingComponent,
    loadChildren: () => import('@account/account.module').then(m => m.AccountModule),
    canActivate: [AuthenticationGuard, ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'benefits',
    component: LandingComponent,
    loadChildren: () => import('@benefits/benefits.module').then(m => m.BenefitsModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'categories',
    component: LandingComponent,
    loadChildren: () => import('@customization/customization.module').then(m => m.CustomizationModule),
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'menu',
    component: LandingComponent,
    loadChildren: () => import('@menu/menu.module').then(m => m.MenuModule),
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'Menu',
    component: LandingComponent,
    loadChildren: () => import('@menu/menu.module').then(m => m.MenuModule),
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'ordering',
    component: LandingComponent,
    loadChildren: () => import('@ordering/ordering.module').then(m => m.OrderingModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    // Added new route for menu to modal to menu redirect
    path: 'locations/:id/menu/reload',
    component: LandingComponent,
    loadChildren: () => import('@menu/menu.module').then(m => m.MenuModule),
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'locations/:id/menu',
    component: LandingComponent,
    loadChildren: () => import('@menu/menu.module').then(m => m.MenuModule),
    // runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'locations/:id/menu',
    component: LandingComponent,
    loadChildren: () => import('@customization/customization.module').then(m => m.CustomizationModule),
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'customization',
    component: LandingComponent,
    loadChildren: () => import('@customization/customization.module').then(m => m.CustomizationModule),
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'locations',
    component: LandingComponent,
    loadChildren: () => import('@location/location.module').then(m => m.LocationModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'order-review',
    component: LandingComponent,
    loadChildren: () => import('@features/checkout/checkout.module').then(m => m.CheckoutModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  // TODO remove this path after finished working on the cart order summary component screen
  {
    path: 'ordersummary',
    component: LandingComponent,
    children: [
      { path: '', component: OrderModals.MyOrderSummaryComponent },
    ]
  },
  // Menu Item Deep linking route handling
  {
    path: 'viewmenuitem',
    component: LandingComponent,
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard]
  },
  {
    path: 'company/contact',
    component: LandingComponent,
    loadChildren: () => import('@contact-us/contact-us.module').then(m => m.ContactUsModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'company',
    component: LandingComponent,
    loadChildren: () => import('@company/company.module').then(m => m.CompanyModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard],
  },
  {
    path: 'Company',
    component: LandingComponent,
    loadChildren: () => import('@company/company.module').then(m => m.CompanyModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard],
  },
  {
    path: 'careers',
    component: LandingComponent,
    loadChildren: () => import('@careers/careers.module').then(m => m.CareersModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'Careers',
    component: LandingComponent,
    loadChildren: () => import('@careers/careers.module').then(m => m.CareersModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'food',
    component: LandingComponent,
    loadChildren: () => import('@food/food.module').then(m => m.FoodModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'contact-us',
    component: LandingComponent,
    loadChildren: () => import('@contact-us/contact-us.module').then(m => m.ContactUsModule),
    canActivate: [ForceHTTPSGuard]
  },
  {
    path: 'groupdining',
    component: LandingComponent,
    loadChildren: () => import('@groupdining/groupdining.module').then(m => m.GroupDiningModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'visits',
    component: LandingComponent,
    loadChildren: () => import('@visit/visit.module').then(m => m.VisitModule),
    canActivate: [ForceHTTPSGuard, AuthenticationGuard,  SubNavGuard, VisitsGuard]
  },
  {
    path: 'franchise',
    component: LandingComponent,
    loadChildren: () => import('@franchise/franchise.module').then(m => m.FranchiseModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'unsubscribe',
    component: LandingComponent,
    loadChildren: () => import('@unsubscribe/unsubscribe.module').then(m => m.UnsubscribeModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'online-gift-card',
    component: LandingComponent,
    loadChildren: () => import('@virtual-gift-card/virtual-gift-card.module').then(m => m.VirtualGiftCardModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'rewards',
    component: LandingComponent,
    loadChildren: () => import('@rewards/rewards.module').then(m => m.RewardsModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'score-more',
    component: LandingComponent,
    loadChildren: () => import('@thank-you-game/thank-you-game.module').then(m => m.ThankYouGameModule),
    canActivate: [ForceHTTPSGuard, SubNavGuard]
  },
  {
    path: 'nonfood',
    component: LandingComponent,
    loadChildren: () => import('@nonfood/nonfood.module').then(m => m.NonfoodModule),
    canActivate: [ForceHTTPSGuard, CheckLocationGuard, SubNavGuard, AuthenticationGuard]
  },
  {
    path: 'auth0/magic-link',
    component: Auth0CallbackComponent,
  },
  {
    path: 'auth0/callback',
    component: Auth0CallbackComponent,
    canActivate: [CiamV6Guard]
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];

export const Routing: ModuleWithProviders<AppModule> = RouterModule.forRoot(appRoutes, {}); // , { enableTracing: true } );
